import {BaseCL} from "./BaseCL";
import {UiFlashMessage, UiLoaderItem} from "./UiFlashMessage";

export class MyBaseCL extends BaseCL {
	protected message: string|string = null;

	constructor(url : string) {
		super();
		this.url = url;
		this.onLoading = () => UiFlashMessage.instance.add(this.message ?? "Komunikuji se serverem.", "loader");
		this.onLoaded = (l : UiLoaderItem) => l.remove();
	}

	public withMessage(message: string): this
	{
		const newCl = new (this as any).constructor(this.url);
		newCl.message = message;
		newCl.context = this.context;
		return newCl;
	}

	protected override updateContext(context: any): any {
		if (context.flashMessages) {
			for(const flashMessage of context.flashMessages)
				UiFlashMessage.instance.add(flashMessage);
		}
		return super.updateContext(context);
	}
}
